module.exports = __webpack_public_path__ + "static/media/window-notest-bg.8aa1960a.png";